import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const HelpModal = ({ show, onClose }) => {
    return (
        <Modal show={show} onHide={onClose} size={"xl"}>
            <Modal.Header closeButton>
                <Modal.Title>Guía de uso</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    En el filtro que se presenta a continuación, según la opción
                    de consulta y descarga de su interés, tendrá las siguientes
                    tres (3) alternativas:
                </p>

                <p className="ms-3">
                    <strong className="TextPantone7406C">1</strong> Para
                    descargar un APU de una provincia de un departamento en
                    específico: en el campo de Departamento deberá indicar el de
                    su interés, en el campo Municipio seleccionará el municipio
                    del departamento relacionado al cual se quiera identificar y
                    obtener precios de la provincia; luego, en el Año y Periodo
                    seleccionar 2021 y 2 ó 2022 y 1, respectivamente. Después de
                    esto, dar clic sobre el{" "}
                    <span className="TextPantone7406C">
                        botón de color amarillo Provincia
                    </span>
                    . Luego de que aparezca un mensaje indicando a cuál
                    provincia pertenece el municipio seleccionado; podrá dar
                    clic en el{" "}
                    <span className="TextPantone7406C">
                        botón amarillo Provincia
                    </span>{" "}
                    en Opción de descarga y automáticamente se descargará el
                    archivo correspondiente.
                </p>

                <p className="ms-3">
                    <strong className="TextPantone2935C">2</strong> Para
                    descargar los APU de todas las provincias de un
                    departamento: en el campo de Departamento deberá indicar el
                    de su interés, no seleccionar ningún municipio y en el Año y
                    Periodo seleccionar 2021 y 2 ó 2022 y 1, respectivamente.
                    Luego, debe dar clic sobre el{" "}
                    <span className="TextPantone2935C">
                        botón de color azul Departamento
                    </span>
                    . Posteriormente aparecerá el mensaje indicando que se
                    encontraron los archivos y deberá dar clic en el{" "}
                    <span className="TextPantone2935C">
                        botón azul Departamento
                    </span>{" "}
                    en Opción de descarga, y automáticamente se descargará un
                    archivo comprimido con los APU.
                </p>

                <p className="ms-3">
                    <strong className="TextPantone376C">3</strong> Para
                    descargar los APU de todas las provincias del país: no
                    deberá seleccionar nada en los campos Departamento y
                    Municipio, sin embargo, es necesario señalar el Año y
                    Periodo de su interés (2021 y 2 ó 2022 y 1,
                    respectivamente). Luego de esto, deberá dar clic en el{" "}
                    <span className="TextPantone376C">
                        botón de color verde País
                    </span>
                    , y para descargar los APU, dar clic en el{" "}
                    <span className="TextPantone376C">botón verde País</span> en
                    Opción de descarga y automáticamente se empezará a descargar
                    un archivo comprimido con la información correspondiente.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Aceptar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default HelpModal;
